import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
    FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ApiService from "../../Api/ApiController";
import Swal from "sweetalert2";

export default function StocksCategoryList() {
  const [categories, setCategories] = useState([]);

  // Dialog states
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  // Current category being edited or deleted
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Form state for editing
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const fetchCategory = () => {
    ApiService.getStockCategory()
      .then((response) => {
        if (response.data.status === true) {
          setCategories(response.data.data);
        } else {
          setCategories([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setCategories([]);
      });
  };

  useEffect(() => {
    fetchCategory();
  }, []);

  // Handle Edit
  const handleEditOpen = (category) => {
    setSelectedCategory(category);
    setFormData({
      name: category.name,
      value: category.value,
      change_value: category.change_value,
      change_percent: category.change_percent,
      direction: category.direction,
      description: category.description,
    });
    setOpenEdit(true);
  };

  const handleEditSave = () => {
    const updatedData = {
        ...formData,
        category_id:selectedCategory._id
    }
    ApiService.updateStockCategory(updatedData)
      .then(() => {
        fetchCategory();
        setOpenEdit(false);
      })
      .catch((err) => console.error(err));
  };

  // Handle Delete
  const handleDeleteOpen = (category) => {
    setSelectedCategory(category);
    setOpenDelete(true);
  };

  const handleDeleteConfirm = () => {
    ApiService.deleteStockCategory(selectedCategory._id)
      .then(() => {
        fetchCategory();
        setOpenDelete(false);
      })
      .catch((err) => console.error(err));
  };
const handleToggleFeatured = (category) => {
    ApiService.toggleFeatured(category._id) // 👈 API call
      .then((response) => {
    if(response.data.status === true){
Swal.fire({
              toast: true,
              position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
              icon: 'success',
              title: response.data.message,
              showConfirmButton: false,
              timer: 3000, // Duration in milliseconds
              timerProgressBar: true,
            });
    }else{
             Swal.fire({
              toast: true,
              position: 'top-end', // You can change this to 'bottom-end', 'bottom-left', etc.
              icon: 'error',
              title: response.data.message,
              showConfirmButton: false,
              timer: 3000, // Duration in milliseconds
              timerProgressBar: true,
            });
    }
        fetchCategory();
      })
      .catch((err) => console.error(err));
  };
  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
      <CardHeader
        title="Stock Categories"
        titleTypographyProps={{ variant: "h6", fontWeight: "bold" }}
      />
      <CardContent>
        <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Category Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Value</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Change Value</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Change Percent</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Direction</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Featured</TableCell>
                <TableCell align="right" sx={{ fontWeight: "bold" }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {categories.map((category, index) => (
                <TableRow key={category._id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{category.name}</TableCell>
                  <TableCell>{category.value || '--'}</TableCell>
                  <TableCell>{category.change_value || '--'}</TableCell>
                  <TableCell>{category.change_percent || '--'}</TableCell>
                  <TableCell>{category.direction || '--'}</TableCell>
                  <TableCell>{category.description || '--'}</TableCell>
                  <TableCell>
  <Switch
    checked={category.isFeatured || false}
    onChange={() => handleToggleFeatured(category)}
    color="primary"
  />
</TableCell>
                  <TableCell align="right">
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => handleEditOpen(category)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleDeleteOpen(category)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>

      {/* Edit Dialog */}
      <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth>
        <DialogTitle>Edit Category</DialogTitle>
        <DialogContent dividers>
          <TextField
            margin="dense"
            label="Index Name"
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Index Name"
            fullWidth
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Index Value"
            fullWidth
            value={formData.value}
            onChange={(e) => setFormData({ ...formData, value: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Change Value"
            fullWidth
            value={formData.change_value}
            onChange={(e) => setFormData({ ...formData, change_value: e.target.value })}
          />
          <TextField
            margin="dense"
            label="Change Percent"
            fullWidth
            value={formData.change_percent}
            onChange={(e) => setFormData({ ...formData, change_percent: e.target.value })}
          />
          <FormControl fullWidth>
                            <InputLabel id="direction-label">Direction</InputLabel>
                            <Select
                              labelId="direction-label"
                              name="direction"
                              value={formData.direction}
                              onChange={(e) => setFormData({ ...formData, direction: e.target.value })}
                              label="Direction" // ✅ fixes label cutting
                            >
                              <MenuItem value="up">Up</MenuItem>
                              <MenuItem value="down">Down</MenuItem>
                            </Select>
                          </FormControl>
          <TextField
            margin="dense"
            label="Description"
            fullWidth
            multiline
            minRows={3}
            value={formData.description}
            onChange={(e) =>
              setFormData({ ...formData, description: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEdit(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleEditSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Are you sure you want to delete category{" "}
            <strong>{selectedCategory?.name}</strong>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleDeleteConfirm}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
}
